
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.103 9.273h8.828c.61 0 1.104.488 1.104 1.09 0 .603-.495 1.091-1.104 1.091H1.103c-.609 0-1.103-.488-1.103-1.09 0-.603.494-1.091 1.103-1.091zm0-4.364h8.828c.61 0 1.104.489 1.104 1.091S10.54 7.09 9.93 7.09H1.103C.494 7.09 0 6.603 0 6c0-.602.494-1.09 1.103-1.09zm8.828-2.182H1.103C.494 2.727 0 2.24 0 1.637 0 1.033.494.544 1.103.544h8.828c.61 0 1.104.49 1.104 1.091 0 .603-.495 1.091-1.104 1.091zm4.414 6c.914 0 1.655.733 1.655 1.637 0 .903-.741 1.636-1.655 1.636a1.646 1.646 0 01-1.655-1.636c0-.904.74-1.637 1.655-1.637zm0-4.363C15.259 4.364 16 5.096 16 6c0 .904-.741 1.636-1.655 1.636A1.646 1.646 0 0112.69 6c0-.904.74-1.636 1.655-1.636zm0-4.364C15.259 0 16 .733 16 1.636c0 .904-.741 1.637-1.655 1.637a1.646 1.646 0 01-1.655-1.637C12.69.733 13.43 0 14.345 0z","fill":"#EDEDE7"}})])
          )
        }
      }
    